var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isActive)?_c('div',{staticClass:"sb-device-orientation-message"},[_c('p',[_vm._v("Please switch back to portrait mode to continue the game")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }